import {Button, Dialog, IconButton} from '@wandb/components';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React, {useContext, useState} from 'react';

import {useViewer} from '../state/viewer/hooks';
import {setViewingAs, unsetViewingAs, viewingAs} from '../util/admin';
import * as Urls from '../util/urls';
import {AccountSelectorContext} from './Search/SearchNav/AccountSelectorContextProvider';
import {SelectUser, type UserOption} from './SelectUser';

type ImpersonateUserModalContentProps = {
  onImpersonate: () => void;
  onClose: () => void;
};

export const ImpersonateUserModal = (
  props: ImpersonateUserModalContentProps
) => {
  const viewer = useViewer();
  const [username, setUsername] = useState('');
  const {setLastNonImpersonatedAccount, selectedAccount} = useContext(
    AccountSelectorContext
  );
  const isSubmitDisabled = username === '';
  const loading = viewer == null;

  const onImpersonateClick = () => {
    setViewingAs(username);
    setLastNonImpersonatedAccount(selectedAccount);
    props.onImpersonate();
    window.location.reload();
  };

  return (
    <Dialog.Modal
      isOpen
      onOpenChange={open => {
        if (!open) {
          props.onClose();
        }
      }}>
      <Dialog.Heading>Select user to impersonate</Dialog.Heading>
      <Dialog.Content>
        <TailwindContents>
          <div className="flex items-center gap-4">
            <div className="flex-auto">
              <SelectUser
                size="large"
                menuPosition="fixed"
                onSelectUser={(user: UserOption | null) =>
                  setUsername(user && user.username ? user.username : '')
                }
              />
            </div>
            <IconButton
              icon="user-profile-personal"
              variant="ghost"
              aria-label="View user's profile page"
              tooltip={{children: "View user's profile page"}}
              isDisabled={isSubmitDisabled}
              href={isSubmitDisabled ? undefined : Urls.profilePage(username)}
              target="_blank"
              rel="noopener noreferrer"
            />
          </div>
        </TailwindContents>
      </Dialog.Content>
      <Dialog.Footer>
        <Button variant="secondary" onPress={props.onClose}>
          Cancel
        </Button>
        <Button
          variant="destructive"
          data-test="stop-impersonate-button"
          isDisabled={viewingAs() === ''}
          onPress={() => {
            unsetViewingAs();
            window.location.reload();
          }}>
          Stop Impersonating
        </Button>
        <Button
          variant="primary"
          data-test="impersonate-button"
          isDisabled={isSubmitDisabled || loading}
          onPress={onImpersonateClick}>
          Impersonate ➞
        </Button>
      </Dialog.Footer>
    </Dialog.Modal>
  );
};
